import React from 'react';
import './StripeLoading.css';

export default function StripeLoading({ visible }) {
  if (!visible) return null;

  return (
    <div className="stripe-loading-overlay">
      <div className="stripe-loading-card">
        <div className="stripe-loading-spinner"></div>
        <h3>Redirection vers le paiement...</h3>
        <p>Tu vas être redirigé vers Stripe pour finaliser ton achat.</p>
      </div>
    </div>
  );
}